const isValidDate = (d: any) => {
    // @ts-ignore
    return d instanceof Date && !isNaN(d)
}

const convertToDate = (date: any, language: any) => {
    const newDate = new Date(date)

    if (!newDate || !isValidDate(newDate) || !date) return ['', '', '']

    const formatDate = (date: any, options: any) =>
        new Intl.DateTimeFormat(
            language === 'ru' ? 'ru-RU' : 'en-US',
            options
        ).format(date)

    const dateOptions = { day: 'numeric', month: 'long' }
    const timeOptions = { hour: '2-digit', minute: '2-digit' }

    const dayMonth = formatDate(newDate, dateOptions)
    const time = formatDate(newDate, timeOptions)

    const [day, month] = dayMonth.split(' ')

    return [day, month, time]
}

export const getFullDate = (date: any, language: any) => {
    const [day, month, time] = convertToDate(date, language)
    return `${day} ${month}, ${time}`;
}

export const getTime = (date: any, language: any) => {
    const [day, month, time] = convertToDate(date, language)
    return time;
}

export const getDateWithoutTime = (date: any, language: any) => {
    const [day, month, time] = convertToDate(date, language)
    return `${day} ${month}`;
}

const addLeadingZero =(number: any) => {
    return number < 10 ? '0' + number : number;
}

export const getFormatDate = (date: any) => {
    const day = addLeadingZero(date.getDate());
    const month = addLeadingZero(date.getMonth() + 1); // Месяцы идут с 0, поэтому добавляем 1
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}

export const getFullFormatDate = (isoString: string) => {
    const date = new Date(isoString);
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}.${month}.${year}, ${hours}:${minutes}`;
  }; const isValidDate = (d: any) => {
    // @ts-ignore
    return d instanceof Date && !isNaN(d)
}

const convertToDate = (date: any, language: any) => {
    const newDate = new Date(date)

    if (!newDate || !isValidDate(newDate) || !date) return ['', '', '']

    const formatDate = (date: any, options: any) =>
        new Intl.DateTimeFormat(
            language === 'ru' ? 'ru-RU' : 'en-US',
            options
        ).format(date)

    const dateOptions = { day: 'numeric', month: 'long' }
    const timeOptions = { hour: '2-digit', minute: '2-digit' }

    const dayMonth = formatDate(newDate, dateOptions)
    const time = formatDate(newDate, timeOptions)

    const [day, month] = dayMonth.split(' ')

    return [day, month, time]
}

export const getFullDate = (date: any, language: any) => {
    const [day, month, time] = convertToDate(date, language)
    return `${day} ${month}, ${time}`;
}

export const getTime = (date: any, language: any) => {
    const [day, month, time] = convertToDate(date, language)
    return time;
}

export const getDateWithoutTime = (date: any, language: any) => {
    const [day, month, time] = convertToDate(date, language)
    return `${day} ${month}`;
}

const addLeadingZero =(number: any) => {
    return number < 10 ? '0' + number : number;
}

export const getFormatDate = (date: any) => {
    const day = addLeadingZero(date.getDate());
    const month = addLeadingZero(date.getMonth() + 1); // Месяцы идут с 0, поэтому добавляем 1
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}

export const getFullFormatDate = (isoString: string) => {
    const date = new Date(isoString);
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}.${month}.${year}, ${hours}:${minutes}`;
  }; 